import { ResponseType, FeedbackType } from 'types'
import requests from '../http'

export const createFeedback = async (
  body: FeedbackType,
): Promise<ResponseType<FeedbackType>> => requests.post(`/users/feedback`, body)
